Monitoring.Views ||= {}

class Monitoring.Views.MovistarTypesConditionEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_types_condition_edit"]

  initialize: (@options = {}) ->
    @initiallySelectedSubtypes = @options.selectedSubtypes

  render : ->
    @$el.html(@template(@))
    @

  getSelectedSubtypes: ->
    @$el.find('input:checked').map((i, cb) -> cb.value).get()
